var magicStyles = [".container[data-v-58bdff76]{max-width:var(--magic-corex-banner-size,344px);margin:0 auto}"];

export default magicStyles;
